<template>
  <div class="auth-management-container figma-auth-page">
    <div class="figma-white-card">
      <div class="figma-page-header">
        <div class="figma-page-title">{{ $t('authManagement.pageTitle') }}</div>
        <div class="figma-header-divider"></div>
        <div class="figma-tabs-row">
          <span
            :class="['figma-tab-item', { 'is-active': activeTab === 'person' }]"
            @click="_switchTab('person')"
          >{{ $t('authManagement.tabs.personAuth') }}</span>
          <span
            :class="['figma-tab-item', { 'is-active': activeTab === 'house' }]"
            @click="_switchTab('house')"
          >{{ $t('authManagement.tabs.houseAudit') }}</span>
        </div>
        <div class="figma-tabs-divider">
          <span :class="['figma-tab-indicator', { 'is-house': activeTab === 'house' }]"></span>
        </div>
        <div class="figma-toolbar-row">
          <div class="figma-btn-group">
            <el-button size="small" class="figma-btn-refresh" title="刷新" @click="_queryMethod">
              <img src="../../../assets/CodeBuddyAssets/616_14508/23.svg" class="btn-icon" />
            </el-button>
          </div>
          <div class="figma-search-group">
            <!-- <el-input
              v-model="conditions.name"
              :placeholder="$t('authManagement.search.keywordPlaceholder')"
              class="figma-search-input"
              clearable
              size="small"
              @keyup.enter.native="_queryMethod"
            /> -->

            <el-input
              v-if="activeTab === 'person'"
              v-model="conditions.appUserName"
              :placeholder="$t('authManagement.search.appUserNamePlaceholder')"
              class="figma-search-input figma-search-input--narrow"
              clearable
              size="small"
              @keyup.enter.native="_queryMethod"
              @clear="_queryMethod"
            />
            <el-input
              v-if="activeTab === 'person'"
              v-model="conditions.idCard"
              :placeholder="$t('authManagement.search.idcardPlaceholder')"
              class="figma-search-input figma-search-input--narrow"
              clearable
              size="small"
              @keyup.enter.native="_queryMethod"
              @clear="_queryMethod"
            />
            <el-input
              v-if="activeTab === 'house'"
              v-model="conditions.roomName"
              :placeholder="$t('authManagement.search.roomNamePlaceholder')"
              class="figma-search-input figma-search-input--narrow"
              clearable
              size="small"
              @keyup.enter.native="_queryMethod"
              @clear="_queryMethod"
            />

            <el-select size="small" v-model="conditions.isOpen"
              :placeholder="$t('authManagement.search.statePlaceholder')" class="figma-search-input" clearable
              @change="_queryMethod">
              <el-option :label="$t('authManagement.search.stateAll')" value="" />
              <el-option :label="$t('authManagement.search.stateNormal')" value="12000" />
              <el-option :label="$t('authManagement.search.stateDisabled')" value="10000" />
              <el-option :label="$t('authManagement.search.stateRejected')" value="13000" />
            </el-select>

            <el-button size="small" class="figma-btn-search" @click="_queryMethod">
              <img src="../../../assets/CodeBuddyAssets/616_14508/24.svg" class="btn-icon" />
              <span>{{ $t('common.search') }}</span>
            </el-button>
          </div>
        </div>
      </div>

      <div class="figma-table-section">
        <el-table v-if="activeTab === 'person'" :data="tableData" style="width: 100%" :header-cell-style="headerCellStyle" :cell-style="cellStyle">
          <el-table-column prop="communityName" :label="$t('authManagement.table.community')" min-width="182">
            <template slot-scope="scope"><span class="text-primary">{{ scope.row.communityName || '-' }}</span></template>
          </el-table-column>
          <el-table-column prop="appUserName" :label="$t('authManagement.table.owner')" min-width="128">
            <template slot-scope="scope"><span class="text-primary">{{ scope.row.appUserName || '-' }}</span></template>
          </el-table-column>
          <el-table-column :label="$t('authManagement.table.authType')" min-width="132">
            <template slot-scope="scope"><span class="cert-type-text">{{ getCertTypeName(scope.row) }}</span></template>
          </el-table-column>
          <el-table-column :label="$t('authManagement.table.idCard')" min-width="200">
            <template slot-scope="scope">{{ getIdCard(scope.row) }}</template>
          </el-table-column>
          <el-table-column :label="$t('authManagement.table.photo')" min-width="160">
            <template slot-scope="scope">
              <span v-if="getPhotoUrls(scope.row).length" class="photo-list">
                <span
                  v-for="(url, index) in getPhotoUrls(scope.row)"
                  :key="index"
                  class="photo-cell"
                  @click="_previewPhoto(scope.row, index)"
                >
                  <img :src="url" class="photo-thumb" />
                </span>
              </span>
              <span v-else class="photo-cell" @click="_previewPhoto(scope.row, 0)">
                <img src="../../../assets/CodeBuddyAssets/616_14508/30.svg" class="photo-placeholder" />
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="stateName" :label="$t('authManagement.table.state')" min-width="148">
            <template slot-scope="scope">
              <span :class="['status-tag', getStateClass(scope.row.state)]">{{ getStateName(scope.row.state) }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('authManagement.table.auditTip')" min-width="136">
            <template slot-scope="scope">{{ getAuditTip(scope.row) }}</template>
          </el-table-column>
          <el-table-column prop="createTime" :label="$t('authManagement.table.applyTime')" min-width="228">
            <template slot-scope="scope">{{ scope.row.createTime || '-' }}</template>
          </el-table-column>
          <el-table-column :label="$t('authManagement.table.auditTime')" min-width="199">
            <template slot-scope="scope">{{ getAuditTime(scope.row) }}</template>
          </el-table-column>
          <el-table-column :label="$t('common.operation')" fixed="right" width="130">
            <template slot-scope="scope">
              <span v-if="isPending(scope.row.state)" class="action-links">
                <a class="action-link" @click="_approveRow(scope.row)">{{ $t('authManagement.action.approve') }}</a>
                <span class="link-separator"></span>
                <a class="action-link" @click="_openRejectDialog(scope.row)">{{ $t('authManagement.action.reject') }}</a>
              </span>
              <span v-else class="action-empty">-</span>
            </template>
          </el-table-column>
        </el-table>

        <el-table v-if="activeTab === 'house'" :data="tableData" style="width: 100%" :header-cell-style="headerCellStyle" :cell-style="cellStyle">
          <el-table-column prop="communityName" :label="$t('authManagement.table.community')" min-width="192">
            <template slot-scope="scope"><span class="text-primary">{{ scope.row.communityName || '-' }}</span></template>
          </el-table-column>
          <el-table-column prop="buildingName" :label="$t('authManagement.table.building')" min-width="158">
            <template slot-scope="scope"><span class="text-primary">{{ scope.row.buildingName || scope.row.buildingNum || '-' }}</span></template>
          </el-table-column>
          <el-table-column prop="roomName" :label="$t('authManagement.table.room')" min-width="158">
            <template slot-scope="scope"><span class="text-primary">{{ scope.row.roomName || scope.row.roomNum || '-' }}</span></template>
          </el-table-column>
          <el-table-column :label="$t('authManagement.table.propertyProof')" min-width="142">
            <template slot-scope="scope">
              <span v-if="getProofUrls(scope.row).length" class="photo-list">
                <span
                  v-for="(url, index) in getProofUrls(scope.row)"
                  :key="index"
                  class="photo-cell"
                  @click="_previewProof(scope.row, index)"
                >
                  <img :src="url" class="photo-thumb" />
                </span>
              </span>
              <span v-else class="text-secondary">{{ '-' }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('authManagement.table.state')" min-width="148">
            <template slot-scope="scope">
              <span :class="['status-tag', getStateClass(scope.row.state)]">{{ getStateName(scope.row.state) }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('authManagement.table.auditTip')" min-width="175">
            <template slot-scope="scope">{{ getAuditTip(scope.row) }}</template>
          </el-table-column>
          <el-table-column prop="createTime" :label="$t('authManagement.table.applyTime')" min-width="240">
            <template slot-scope="scope">{{ scope.row.createTime || '-' }}</template>
          </el-table-column>
          <el-table-column :label="$t('authManagement.table.auditTime')" min-width="240">
            <template slot-scope="scope">{{ getAuditTime(scope.row) }}</template>
          </el-table-column>
          <el-table-column :label="$t('common.operation')" fixed="right" width="130">
            <template slot-scope="scope">
              <span v-if="isPending(scope.row.state)" class="action-links">
                <a class="action-link" @click="_approveRow(scope.row)">{{ $t('authManagement.action.approve') }}</a>
                <span class="link-separator"></span>
                <a class="action-link" @click="_openRejectDialog(scope.row)">{{ $t('authManagement.action.reject') }}</a>
              </span>
              <span v-else class="action-empty">-</span>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="figma-pagination">
        <span class="pagination-total">共{{ pagination.total }}条</span>
        <el-pagination
          :current-page="pagination.current"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pagination.size"
          layout="prev, pager, next"
          :total="pagination.total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
        <el-select v-model="pagination.size" size="small" class="pagination-size-select" @change="handleSizeChange">
          <el-option label="10条/页" :value="10" />
          <el-option label="20条/页" :value="20" />
          <el-option label="50条/页" :value="50" />
        </el-select>
      </div>
    </div>

    <el-dialog :title="$t('authManagement.audit.rejectTitle')" :visible.sync="rejectDialogVisible" width="650px" custom-class="figma-reject-dialog" :close-on-click-modal="false" @close="_handleRejectDialogClose">
      <el-form ref="rejectForm" :model="rejectForm" :rules="rejectRules" label-width="86px" label-position="left" class="dialog-form">
        <el-form-item :label="$t('authManagement.audit.rejectReason') + ':'" prop="reason">
          <el-input v-model="rejectForm.reason" type="textarea" :rows="4" :placeholder="$t('authManagement.audit.rejectReasonPlaceholder')" class="dialog-textarea" resize="none" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" class="btn-cancel" @click="rejectDialogVisible = false">{{ $t('authManagement.audit.cancel') }}</el-button>
        <el-button size="small" class="btn-confirm" @click="_submitReject">{{ $t('authManagement.audit.confirm') }}</el-button>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="imagePreviewVisible" width="720px" custom-class="photo-preview-dialog" append-to-body>
      <div class="photo-preview-body">
        <el-button v-if="imagePreviewUrls.length > 1" class="photo-preview-arrow is-left" icon="el-icon-arrow-left" circle @click="_prevPreviewPhoto" />
        <img v-if="currentPreviewUrl" :src="currentPreviewUrl" class="photo-preview-img" />
        <el-button v-if="imagePreviewUrls.length > 1" class="photo-preview-arrow is-right" icon="el-icon-arrow-right" circle @click="_nextPreviewPhoto" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { listAuthManagement, auditAuthOwner, listAuthOwnerRooms, auditAuthOwnerRoom } from '@/api/platform/platformApi'

export default {
  name: 'AuthManagementList',
  data() {
    return {
      activeTab: 'person',
      conditions: { name: '', isOpen: '', appUserName: '', idCard: '', roomName: '' },
      tableData: [],
      pagination: { current: 1, size: 10, total: 0 },
      rejectDialogVisible: false,
      rejectForm: { id: '', reason: '' },
      rejectRules: {
        reason: [{ required: true, message: this.$t('authManagement.validate.rejectReasonRequired'), trigger: 'blur' }]
      },
      imagePreviewVisible: false,
      imagePreviewUrls: [],
      imagePreviewIndex: 0
    }
  },
  created() {
    this._listData(this.pagination.current, this.pagination.size)
  },
  computed: {
    currentPreviewUrl() {
      return this.imagePreviewUrls[this.imagePreviewIndex] || ''
    }
  },
  methods: {
    _switchTab(tab) {
      if (this.activeTab === tab) return
      this.activeTab = tab
      this._queryMethod()
    },
    _listData(page, size) {
      const params = { page, row: size }
      if (this.conditions.name) {
        params.communityName = this.conditions.name
      }
      if (this.conditions.isOpen) {
        params.state = this.conditions.isOpen
      }
      let request
      if (this.activeTab === 'person') {
        params.ownerTypeCd = ''
        if (this.conditions.appUserName) {
          params.appUserName = this.conditions.appUserName
        }
        if (this.conditions.idCard) {
          params.idCard = this.conditions.idCard
        }
        request = listAuthManagement(params)
      } else {
        if (this.conditions.roomName) {
          params.roomName = this.conditions.roomName
        }
        request = listAuthOwnerRooms(params)
      }
      request.then(res => {
        this.tableData = res.records || []
        this.pagination.total = res.total || 0
      }).catch(error => {
        console.error('请求失败处理', error)
      })
    },
    _queryMethod() {
      this.pagination.current = 1
      this._listData(this.pagination.current, this.pagination.size)
    },
    _approveRow(row) {
      this.$confirm(this.$t('authManagement.audit.approveConfirm'), this.$t('authManagement.audit.approveTitle'), {
        confirmButtonText: this.$t('authManagement.action.approve'),
        cancelButtonText: this.$t('authManagement.audit.cancel'),
        type: 'warning'
      }).then(() => {
        if (this.activeTab === 'person') {
          // 人员认证审核：使用 appUserId，状态码 12000
          auditAuthOwner({ appUserId: row.appUserId, state: '12000' }).then(() => {
            this.$message.success(this.$t('authManagement.audit.approveSuccess'))
            this._queryMethod()
          }).catch(error => { console.error('审核失败', error) })
        } else {
          // 房屋审核：使用 roomDetailId，状态码 12000
          auditAuthOwnerRoom({ roomDetailId: row.roomDetailId, state: '12000', remark: '审核通过' }).then(() => {
            this.$message.success(this.$t('authManagement.audit.approveSuccess'))
            this._queryMethod()
          }).catch(error => { console.error('审核失败', error) })
        }
      }).catch(() => {})
    },
    _openRejectDialog(row) {
      this.rejectForm = { rowId: this.activeTab === 'person' ? row.appUserId : row.roomDetailId, reason: '' }
      this.rejectDialogVisible = true
    },
    _submitReject() {
      this.$refs.rejectForm.validate((valid) => {
        if (!valid) return
        if (this.activeTab === 'person') {
          auditAuthOwner({ appUserId: this.rejectForm.rowId, state: '13000', remark: this.rejectForm.reason }).then(() => {
            this.$message.success(this.$t('authManagement.audit.rejectSuccess'))
            this.rejectDialogVisible = false
            this._queryMethod()
          }).catch(error => { console.error('审核失败', error) })
        } else {
          auditAuthOwnerRoom({ roomDetailId: this.rejectForm.rowId, state: '13000', remark: this.rejectForm.reason }).then(() => {
            this.$message.success(this.$t('authManagement.audit.rejectSuccess'))
            this.rejectDialogVisible = false
            this._queryMethod()
          }).catch(error => { console.error('审核失败', error) })
        }
      })
    },
    _handleRejectDialogClose() {
      this.$refs.rejectForm && this.$refs.rejectForm.resetFields()
      this.rejectForm.reason = ''
    },
    _previewPhoto(row, index = 0) {
      const urls = this.getPhotoUrls(row)
      if (!urls.length) {
        this.$message.info(this.$t('authManagement.audit.noPhoto'))
        return
      }
      this.imagePreviewUrls = urls
      this.imagePreviewIndex = index
      this.imagePreviewVisible = true
    },
    _previewProof(row, index = 0) {
      const urls = this.getProofUrls(row)
      if (!urls.length) {
        this.$message.info(this.$t('authManagement.audit.noPhoto'))
        return
      }
      this.imagePreviewUrls = urls
      this.imagePreviewIndex = index
      this.imagePreviewVisible = true
    },
    _prevPreviewPhoto() {
      if (!this.imagePreviewUrls.length) return
      this.imagePreviewIndex = (this.imagePreviewIndex - 1 + this.imagePreviewUrls.length) % this.imagePreviewUrls.length
    },
    _nextPreviewPhoto() {
      if (!this.imagePreviewUrls.length) return
      this.imagePreviewIndex = (this.imagePreviewIndex + 1) % this.imagePreviewUrls.length
    },
    getPhotoUrls(row) {
      const value = row.id_card_urls || row.idCardUrls || row.photoUrl || row.idCardPhoto || row.cardPhoto || row.photo || row.fileUrl || ''
      if (Array.isArray(value)) return value.filter(Boolean)
      if (!value) return []
      const text = String(value).trim()
      if (!text) return []
      if (text.startsWith('[')) {
        try {
          const list = JSON.parse(text)
          return Array.isArray(list) ? list.filter(Boolean) : []
        } catch (e) {}
      }
      return text.split(/[,;，；\n]/).map(item => item.trim()).filter(Boolean)
    },
    getProofUrls(row) {
      const value = row.propertyCertificateUrl || row.proofUrl || row.proofUrls || row.propertyProof || row.certificateUrl || row.fileUrl || ''
      if (Array.isArray(value)) return value.filter(Boolean)
      if (!value) return []
      const text = String(value).trim()
      if (!text) return []
      if (text.startsWith('[')) {
        try {
          const list = JSON.parse(text)
          return Array.isArray(list) ? list.filter(Boolean) : []
        } catch (e) {}
      }
      return text.split(/[,;，；\n]/).map(item => item.trim()).filter(Boolean)
    },
    getPhotoPreviewList(row, index) {
      const urls = this.getPhotoUrls(row)
      return urls.slice(index).concat(urls.slice(0, index))
    },
    getPhotoUrl(row) {
      return this.getPhotoUrls(row)[0] || ''
    },
    getCertTypeName(row) {
      return row.certTypeName || row.cardTypeName || row.idCardTypeName || row.certificateTypeName || row.certName || row.cardType || row.idCardType || this.$t('authManagement.certType.idCard')
    },
    getIdCard(row) {
      return row.idCard || row.idCardNo || row.cardId || row.identityCard || row.idNumber || row.certNo || '-'
    },
    getAuditTip(row) {
      return row.auditTip || row.auditMessage || row.auditRemark || row.remark || '-'
    },
    getAuditTime(row) {
      return row.auditTime || row.auditDate || row.updateTime || row.statusCdTime || '-'
    },
    getStateName(state) {
      const map = {
        '0': this.$t('authManagement.status.pending'),
        '1000': this.$t('authManagement.status.pending'),
        '10000': this.$t('authManagement.status.pending'),
        '12000': this.$t('authManagement.status.approved'),
        '13000': this.$t('authManagement.status.rejected')
      }
      return map[state] || state || '-'
    },
    getStateClass(state) {
      const map = {
        '0': 'status-pending',
        '1000': 'status-pending',
        '10000': 'status-pending',
        '12000': 'status-approved',
        '13000': 'status-rejected'
      }
      return map[state] || 'status-default'
    },
    isPending(state) {
      return ['0', '1000', '10000'].includes(String(state))
    },
    getOwnerTypeCdName(ownerTypeCd) {
      const map = {
        '1001': this.$t('authManagement.ownerType.house'),
        '1002': this.$t('authManagement.ownerType.tenant'),
        '1003': this.$t('authManagement.ownerType.family'),
        '2002': this.$t('authManagement.ownerType.family')
      }
      return map[ownerTypeCd] || ownerTypeCd || '-'
    },
    handleSizeChange(val) {
      this.pagination.size = val
      this._listData(this.pagination.current, val)
    },
    handleCurrentChange(val) {
      this.pagination.current = val
      this._listData(val, this.pagination.size)
    },
    headerCellStyle() {
      return { background: '#EBF2FA', color: '#364153', fontSize: '14px', fontWeight: '500', fontFamily: 'PingFang SC', height: '50px', padding: '0' }
    },
    cellStyle({ row }) {
      const rowIndex = this.tableData.indexOf(row)
      return rowIndex % 2 === 1
        ? { background: '#F8FBFF', color: '#1D2129', fontSize: '14px', fontFamily: 'PingFang SC', height: '50px', padding: '0' }
        : { background: '#FFFFFF', color: '#1D2129', fontSize: '14px', fontFamily: 'PingFang SC', height: '50px', padding: '0' }
    }
  }
}
</script>

<style scoped>
.auth-management-container {
  height: 100%;
  background: #EBF2FA;
  padding: 0;
  overflow: hidden;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}

/* 页面标题 */
.page-title-bar {
  display: flex;
  align-items: center;
  padding: 12px 24px;
  gap: 8px;
}
.page-title-icon {
  display: flex;
  align-items: center;
  justify-content: center;
}
.page-title {
  font-size: 16px;
  font-weight: 500;
  color: #1D2129;
  font-family: 'PingFang SC';
}

/* Tab 栏 */
.tab-bar {
  padding: 0 24px;
  position: relative;
}
.tab-header {
  display: flex;
  gap: 32px;
}
.tab-item {
  font-size: 14px;
  font-weight: 500;
  color: #1D2129;
  font-family: 'PingFang SC';
  cursor: pointer;
  padding-bottom: 8px;
  transition: color 0.2s;
}
.tab-item:hover {
  color: #0E76FF;
}
.tab-active {
  color: #0E76FF;
}
.tab-indicator {
  position: absolute;
  bottom: 0;
  width: 56px;
  height: 2px;
  background: #0E76FF;
  border-radius: 1px;
  transition: left 0.3s;
}

/* 搜索栏 */
.search-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 24px;
}
.search-left {
  display: flex;
  align-items: center;
  gap: 8px;
}
.btn-refresh {
  width: 38px;
  height: 38px;
  border-radius: 10px !important;
  border: 1px solid #DCE6F5 !important;
  background: white !important;
  color: #6A7282 !important;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 !important;
}
.btn-refresh:hover {
  border-color: #0E76FF !important;
  color: #0E76FF !important;
}
.search-right {
  display: flex;
  align-items: center;
  gap: 8px;
}
.search-input {
  width: 256px;
}
.search-input >>> .el-input__inner {
  border-radius: 10px;
  border: none;
  outline: 1px #DCE6F5 solid;
  outline-offset: -1px;
  height: 38px;
  font-size: 14px;
  background: white;
}
.search-input >>> .el-input__inner:focus {
  outline: 1px #0E76FF solid;
}
.search-input >>> .el-input__inner::placeholder {
  color: #8C9BB4;
}
.btn-search {
  height: 38px;
  border-radius: 10px !important;
  border: none !important;
  outline: 1px #0E76FF solid !important;
  outline-offset: -1px;
  color: #0E76FF !important;
  background: white !important;
  font-size: 14px;
  font-weight: 500;
  padding: 0 16px !important;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.btn-search:hover {
  background: rgba(14, 118, 255, 0.08) !important;
}

/* 表格 */
.table-section {
  flex: 1;
  padding: 0 24px;
  overflow: auto;
}
.table-section >>> .el-table {
  border-radius: 8px;
  overflow: hidden;
  border: none;
}
.table-section >>> .el-table__header th {
  background: #EBF2FA !important;
  border: none !important;
}
.table-section >>> .el-table__body td {
  border: none !important;
  border-bottom: 1px solid #F0F0F0 !important;
}
.table-section >>> .el-table__body tr:nth-child(even) td {
  background: #F8FBFF;
}
.table-section >>> .el-table::before {
  display: none;
}
.text-primary {
  color: #1D2129;
  font-weight: 400;
}

/* 状态标签 */
.status-tag {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 400;
  font-family: 'PingFang SC';
}
.status-approved {
  background: rgba(14, 118, 255, 0.10);
  color: #0E76FF;
  outline: 1px #0E76FF solid;
  outline-offset: -1px;
}
.status-pending {
  background: rgba(255, 153, 0, 0.10);
  color: #FF9900;
  outline: 1px #FF9900 solid;
  outline-offset: -1px;
}
.status-rejected {
  background: rgba(251, 44, 54, 0.10);
  color: #FB2C36;
  outline: 1px #FB2C36 solid;
  outline-offset: -1px;
}
.status-default {
  background: rgba(140, 155, 180, 0.10);
  color: #8C9BB4;
  outline: 1px #8C9BB4 solid;
  outline-offset: -1px;
}

/* 操作链接 */
.action-links {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0;
}
.action-link {
  color: #0E76FF;
  font-size: 14px;
  font-weight: 500;
  font-family: 'PingFang SC';
  cursor: pointer;
  text-decoration: none;
}
.action-link:hover {
  text-decoration: underline;
}
.link-separator {
  color: transparent;
  font-size: 14px;
}

/* 证件照缩略图 */
.photo-cell {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  width: 32px;
  height: 32px;
}
.photo-thumb {
  width: 32px;
  height: 32px;
  object-fit: cover;
  border-radius: 4px;
}

/* 分页 */
.pagination-section {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 16px 24px;
  gap: 12px;
  border-top: 1px solid #DCE6F5;
}
.pagination-total {
  font-size: 14px;
  font-weight: 500;
  color: #1D2129;
  font-family: 'PingFang SC';
}
.pagination-section >>> .el-pagination {
  display: flex;
  align-items: center;
}
.pagination-section >>> .el-pager li {
  border-radius: 8px;
  min-width: 32px;
  height: 32px;
  line-height: 32px;
}
.pagination-section >>> .el-pager li.active {
  background: #E8F3FF;
  color: #0E76FF;
  font-weight: 600;
}
.pagination-section >>> .btn-prev,
.pagination-section >>> .btn-next {
  border-radius: 2px;
  width: 32px;
  height: 32px;
}
.pagination-size-select {
  width: 90px;
}
.pagination-size-select >>> .el-input__inner {
  border-radius: 8px;
  background: #F2F3F5;
  border: none;
  font-size: 14px;
  height: 32px;
}

/* 驳回弹窗 */
.figma-reject-dialog >>> .el-dialog {
  border-radius: 12px;
  overflow: hidden;
}
.figma-reject-dialog >>> .el-dialog__header {
  background: #EBF2FA;
  padding: 0 24px;
  height: 66px;
  line-height: 66px;
  border-bottom: 1px solid #DCE6F5;
}
.figma-reject-dialog >>> .el-dialog__title {
  font-size: 16px;
  font-weight: 600;
  color: #1D2129;
  font-family: 'PingFang SC';
}
.figma-reject-dialog >>> .el-dialog__headerbtn .el-dialog__close {
  color: #6A7282;
}
.figma-reject-dialog >>> .el-dialog__body {
  padding: 24px 24px 0;
}
.figma-reject-dialog >>> .el-dialog__footer {
  padding: 16px 24px 24px;
}
.dialog-form >>> .el-form-item {
  margin-bottom: 16px;
}
.dialog-form >>> .el-form-item__label {
  font-size: 14px;
  font-weight: 400;
  color: #1D2129;
  font-family: 'PingFang SC';
  line-height: 38px;
  padding-right: 8px;
}
.dialog-form >>> .el-form-item__label::before {
  color: #FB2C36;
}
.dialog-form >>> .el-form-item__error {
  font-size: 12px;
  padding-top: 4px;
}
.dialog-textarea >>> .el-textarea__inner {
  border-radius: 10px;
  border: 1px solid #DCE6F5;
  font-size: 14px;
  font-family: 'PingFang SC';
  color: #1D2129;
  padding: 12px 16px;
  line-height: 22px;
}
.dialog-textarea >>> .el-textarea__inner:focus {
  border-color: #0E76FF;
  outline: none;
}
.dialog-textarea >>> .el-textarea__inner::placeholder {
  color: #8C9BB4;
}
.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}
.btn-cancel {
  height: 38px;
  border-radius: 10px !important;
  border: none !important;
  outline: 1px #0E76FF solid !important;
  outline-offset: -1px;
  color: #0E76FF !important;
  background: white !important;
  font-size: 14px;
  font-weight: 500;
  padding: 0 24px !important;
}
.btn-cancel:hover {
  background: rgba(14, 118, 255, 0.08) !important;
}
.btn-confirm {
  height: 38px;
  border-radius: 10px !important;
  background: #0E76FF !important;
  border: none !important;
  color: white !important;
  font-size: 14px;
  font-weight: 500;
  padding: 0 24px !important;
}
.btn-confirm:hover {
  background: #0A6AE5 !important;
}

/* Figma 616_14508 overrides */
.auth-management-container {
  height: calc(100vh - 92px);
  min-height: 0;
  background: #FFFFFF;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.figma-white-card {
  flex: 1;
  min-height: 0;
  background: #FFFFFF;
  border-radius: 12px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.figma-page-header {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 20px 24px 0;
}
.figma-page-title {
  align-self: flex-start;
  width: 100%;
  text-align: left;
  color: #1D2129;
  font-size: 16px;
  line-height: 22px;
  font-weight: 500;
  font-family: 'PingFang SC', sans-serif;
}
.figma-header-divider {
  width: 100%;
  height: 1px;
  background: #EDF2FA;
  margin-top: 22px;
}
.figma-tabs-row {
  display: flex;
  align-items: center;
  gap: 40px;
  height: 22px;
  margin-top: 20px;
}
.figma-tab-item {
  color: #1D2129;
  font-size: 14px;
  line-height: 20px;
  font-weight: 500;
  font-family: 'PingFang SC', sans-serif;
  cursor: pointer;
  white-space: nowrap;
}
.figma-tab-item.is-active {
  color: #0E76FF;
}
.figma-tabs-divider {
  position: relative;
  width: 100%;
  height: 1px;
  background: #EDF2FA;
  margin-top: 20px;
}
.figma-tab-indicator {
  position: absolute;
  left: 14px;
  bottom: -1px;
  width: 28px;
  height: 2px;
  border-radius: 1px;
  background: #0E76FF;
  transition: left 0.2s ease;
}
.figma-tab-indicator.is-house {
  left: 110px;
}
.figma-toolbar-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-top: 24px;
}
.figma-btn-group,
.figma-search-group {
  display: flex;
  align-items: center;
  gap: 8px;
}
.figma-search-group {
  margin-left: auto;
}
.figma-btn-refresh {
  width: 38px;
  height: 38px;
  border-radius: 10px !important;
  border: 1px solid #DCE6F5 !important;
  background: #FFFFFF !important;
  padding: 0 !important;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.figma-btn-refresh:hover {
  border-color: #0E76FF !important;
}
.figma-btn-refresh .btn-icon {
  width: 16px;
  height: 16px;
}
.figma-search-input {
  width: 256px;
}
.figma-search-input.figma-search-input--narrow {
  width: 180px;
}
.figma-search-input >>> .el-input__inner {
  height: 38px;
  border: none;
  outline: 1px solid #DCE6F5;
  outline-offset: -1px;
  border-radius: 10px;
  background: #FFFFFF;
  color: #1D2129;
  font-size: 14px;
  font-family: Inter, 'PingFang SC', sans-serif;
  padding: 0 16px;
}
.figma-search-input >>> .el-input__inner:focus {
  outline-color: #0E76FF;
}
.figma-search-input >>> .el-input__inner::placeholder {
  color: #8C9BB4;
}
.figma-btn-search {
  width: 84px;
  height: 38px;
  border-radius: 10px !important;
  border: none !important;
  outline: 1px solid #0E76FF !important;
  outline-offset: -1px;
  background: #FFFFFF !important;
  color: #0E76FF !important;
  font-size: 14px;
  font-weight: 500;
  font-family: Inter, 'PingFang SC', sans-serif;
  padding: 0 !important;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}
.figma-btn-search:hover {
  background: rgba(14, 118, 255, 0.08) !important;
}
.figma-btn-search .btn-icon {
  width: 14px;
  height: 14px;
}
.figma-table-section {
  flex: 1;
  min-height: 0;
  padding: 24px 24px 0;
  overflow: auto;
}
.figma-table-section >>> .el-table {
  border-radius: 0;
  overflow: hidden;
  border: none;
  color: #1D2129;
  font-family: 'PingFang SC', sans-serif;
}
.figma-table-section >>> .el-table__header th {
  background: #EBF2FA !important;
  border: none !important;
}
.figma-table-section >>> .el-table__body td {
  border: none !important;
  border-bottom: 1px solid #F0F0F0 !important;
}
.figma-table-section >>> .el-table__body tr:nth-child(even) td {
  background: #F8FBFF !important;
}
.figma-table-section >>> .el-table .cell {
  padding-left: 24px;
  padding-right: 24px;
  line-height: 22px;
}
.figma-table-section >>> .el-table::before {
  display: none;
}
.text-primary {
  color: #1D2129;
  font-weight: 500;
}
.text-secondary {
  color: #8C9BB4;
  font-size: 14px;
}
.cert-type-text {
  color: #21B956;
  font-size: 14px;
  font-weight: 500;
}
.photo-list {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  max-width: 144px;
  overflow-x: auto;
  vertical-align: middle;
}
.photo-cell {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  cursor: pointer;
}
.photo-thumb,
.photo-placeholder {
  width: 38px;
  height: 38px;
  object-fit: cover;
}
.photo-thumb {
  border-radius: 4px;
}
.auth-management-container >>> .photo-preview-dialog .el-dialog__body {
  padding: 16px;
}
.photo-preview-body {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 420px;
  background: #F7F9FC;
  border-radius: 8px;
}
.photo-preview-img {
  max-width: 100%;
  max-height: 70vh;
  object-fit: contain;
}
.photo-preview-arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1;
}
.photo-preview-arrow.is-left {
  left: 16px;
}
.photo-preview-arrow.is-right {
  right: 16px;
}
.status-tag {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 66px;
  height: 28px;
  padding: 0 12px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  box-sizing: border-box;
}
.status-approved {
  background: rgba(14, 118, 255, 0.10);
  color: #0E76FF;
  outline: 1px solid #0E76FF;
  outline-offset: -1px;
}
.status-pending {
  background: rgba(255, 105, 0, 0.10);
  color: #FF6900;
  outline: 1px solid #FF6900;
  outline-offset: -1px;
}
.status-rejected {
  background: rgba(251, 44, 54, 0.10);
  color: #FB2C36;
  outline: 1px solid #FB2C36;
  outline-offset: -1px;
}
.status-default {
  background: rgba(140, 155, 180, 0.10);
  color: #8C9BB4;
  outline: 1px solid #8C9BB4;
  outline-offset: -1px;
}
.action-links {
  display: inline-flex;
  align-items: center;
  gap: 12px;
}
.action-link {
  color: #0E76FF;
  font-size: 14px;
  font-weight: 500;
  text-decoration: none;
  cursor: pointer;
  white-space: nowrap;
}
.action-link:hover {
  text-decoration: underline;
}
.link-separator {
  display: none;
}
.action-empty {
  color: #8C9BB4;
  font-size: 14px;
}
.figma-pagination {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 16px 24px;
  gap: 8px;
  border-top: none;
}
.pagination-total {
  color: #1D2129;
  font-size: 14px;
  font-weight: 500;
  font-family: 'PingFang SC', sans-serif;
  margin-right: 4px;
}
.figma-pagination >>> .el-pagination {
  display: flex;
  align-items: center;
  padding: 0;
}
.figma-pagination >>> .el-pager li {
  min-width: 32px;
  height: 32px;
  line-height: 32px;
  border-radius: 8px;
  font-size: 14px;
}
.figma-pagination >>> .el-pager li.active {
  background: #E8F3FF;
  color: #0E76FF;
  font-weight: 600;
}
.figma-pagination >>> .btn-prev,
.figma-pagination >>> .btn-next {
  width: 32px;
  height: 32px;
  border-radius: 2px;
  padding: 0;
}
.pagination-size-select {
  width: 90px;
  margin-left: 0;
}
.pagination-size-select >>> .el-input__inner {
  height: 32px;
  border: none;
  border-radius: 8px;
  background: #F2F3F5;
  color: #1D2129;
  font-size: 14px;
  font-weight: 500;
  font-family: 'PingFang SC', sans-serif;
}
@media (max-width: 1024px) {
  .auth-management-container {
    height: auto;
    min-height: calc(100vh - 92px);
  }
  .figma-toolbar-row {
    align-items: flex-start;
    flex-direction: column;
    gap: 16px;
  }
  .figma-search-group {
    width: 100%;
    margin-left: 0;
  }
  .figma-search-input,
  .figma-search-input.figma-search-input--narrow {
    width: 100%;
  }
}
@media (max-width: 768px) {
  .figma-page-header,
  .figma-table-section,
  .figma-pagination {
    padding-left: 16px;
    padding-right: 16px;
  }
  .figma-pagination {
    flex-wrap: wrap;
  }
}
</style>
